var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Lottie',{staticClass:"loader",attrs:{"options":_vm.loaderData,"width":_vm.size,"height":_vm.size},on:{"animCreated":_vm.handleAnimation}})}
var staticRenderFns = []

export { render, staticRenderFns }